import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, hasSession, isLoading: authLoading } = useAuth();

  if (authLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #0a0a14 0%, #1a1a2e 100%)'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div className="spinner" style={{ margin: '0 auto 16px' }}></div>
          <p style={{ color: 'rgba(255, 255, 255, 0.6)' }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user && !hasSession) {
    return <Navigate to="/" replace />;
  }

  return children;
}
